export default __webpack_public_path__ + "static/media/tim-ios-success-icon.92523e9e.png";